import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { goBack } from 'connected-react-router';

import { Box, BoxSeparator, ForbiddenSection, Page, TitleBox, ContentBox } from '../../components';
import { business as businessActions } from '../../actions';
import { Language, Utils } from '../../utils';

import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import makeClasses from './styles';
import { Grid, Hidden } from '@material-ui/core';
import clsx from 'clsx';
import { Policies } from '../../utils/Policies';
import moment from 'moment';

const OperationDetailsScreen = props => {
  const dispatch = useDispatch();
  const classes = makeClasses();

  const [ operationDetails, setOperationDetails ] = useState({});
  const [ forbiddenSection, setForbbidenSection ] = useState(false);
  const hasOperationDetails = Object.keys(operationDetails).length > 0;
  const operationId = props.match.params.operationId || null;
  const branchId = props.match.params.branchId || null;
  const { policies, languageTexts } = useSelector(state => ({
    policies: state.user.userData.policies || [],
    languageTexts: state.language.texts || {},
  }));
  const groupedOperationDetails = groupTransactionData(operationDetails.cardAuthorization)
  const i18n = Language(languageTexts);

  useEffect(
    () => {
      window.scrollTo(0, 0);

      if (policies && policies.includes(Policies.types.OPERATION_DEATAILS)) {
        dispatch(
          businessActions.getOperationDetails(operationId, details => {
            setOperationDetails(details);
          })
        );
      } else {
        setForbbidenSection(true);
      }
    },
    [ policies, operationId, branchId ]
  );

  const _goBack = e => {
    e.preventDefault();
    dispatch(goBack());
  };

  const getOperationTypeTitle = () => {
    const operationsTypes = i18n.get("OperationDetails.OperationsTypes");
    const fallback = operationsTypes["Fallback"];
    const operationTypeKey = i18n.get("OperationDetails.OperationTypeKey")

    const type =
      operationDetails?.cardAuthorization?.find(
        (line) => line.data === operationTypeKey
      )?.text;

    return operationsTypes[type] || fallback;
  };

  function groupTransactionData(items) {
    if(!items || items.length === 0) {
      return {
         operationType: [], paymentMethod: [], channel: []
      }
    }
    const AUTH_REGEX = /BANDES|BBVA|ITAU|BROU|SCOTIABANK|SCOTIA_AMEX|AMEX|PAGO_DESPUES|PASSCARD|SISTARBANC|REDPAGOS|EDENRED|CLUB_DEL_ESTE|ANDA|CABAL|MASTER|OCAVISA_NET|VISA|OCA|CREDITOS_DIRECTOS|TOKE/i;

    const findByData = (label) => items.find((i) => i.data === label);
    const findByAuth = () => items.find((i) => AUTH_REGEX.test(i.data));

    const operationType = [
      findByData("Fecha transacción"),
      findByData("Tipo de transacción"),
      findByAuth(),
      findByData("Nro. Ticket"),
      findByData("Nro. Factura"),
      findByData("Sucursal"),
      findByData("Cobro en Cuenta Handy"),
      findByData("Nro. de verificación"),
    ].filter(Boolean); 

    const paymentMethod = [
      findByAuth(),
      findByData("Banco emisor"),
      findByData("Nro. Tarjeta"),
      findByData("Extranjera"),
      findByData("Devolución de impuestos"),
    ].filter(Boolean);

  
    const channel = [
      findByData("Medio"),
      findByData("Terminal"),
      findByData("Identificador de pago Ecommerce"),
    ].filter(Boolean);

    return { operationType, paymentMethod, channel };
  };

  const renderCardAuthorizationLineLabel = data => {
    if (
      /BANDES|BBVA|ITAU|BROU|SCOTIABANK|SCOTIA_AMEX|AMEX|PAGO_DESPUES|PASSCARD|SISTARBANC|REDPAGOS|EDENRED|CLUB_DEL_ESTE|ANDA|CABAL|MASTER|OCAVISA_NET|VISA|OCA|CREDITOS_DIRECTOS|TOKE/.test(
        data.toUpperCase()
      )
    ) {
      return (
        <ListItemText primary={i18n.get('OperationDetails.AutorizationLabel')} />
      );
    }

    return <ListItemText primary={data} />;
  };

   const renderOperationTypesLabels = data => {
    if (
      /BANDES|BBVA|ITAU|BROU|SCOTIABANK|SCOTIA_AMEX|AMEX|PAGO_DESPUES|PASSCARD|SISTARBANC|REDPAGOS|EDENRED|CLUB_DEL_ESTE|ANDA|CABAL|MASTER|OCAVISA_NET|VISA|OCA|CREDITOS_DIRECTOS|TOKE/.test(
        data.toUpperCase()
      )
    ) {
      return (
        <ListItemText primary={i18n.get('OperationDetails.AutorizationLabel')} />
      );
    }

    return <ListItemText primary={data} />;
  };

  const renderPaymentMethodDataLabels = data => {
    if (
      /BANDES|BBVA|ITAU|BROU|SCOTIABANK|SCOTIA_AMEX|AMEX|PAGO_DESPUES|PASSCARD|SISTARBANC|REDPAGOS|EDENRED|CLUB_DEL_ESTE|ANDA|CABAL|MASTER|OCAVISA_NET|VISA|OCA|CREDITOS_DIRECTOS|TOKE/.test(
        data.toUpperCase()
      )
    ) {
      return (
        <ListItemText primary={i18n.get('OperationDetails.BrandLabel')} />
      );
    }

    return <ListItemText primary={data} />;
  };

  const renderCardAuthorizationLineText = (data, isDate, showTime) => {
    if (isDate) {
      if (showTime) {
        const dateData = `${moment(data).format(i18n.get('DateFormat', false))} ${moment(data).format(
          i18n.get('TimeFormat', false)
        )}`;
        return dateData;
      }
      return data ? moment(data).format(i18n.get('DateFormat', false)) : '-';
    }
    return data ? data : '-'
  };

  const renderPaymentMethodLineText = (line) => {
    if (
      /BANDES|BBVA|ITAU|BROU|SCOTIABANK|SCOTIA_AMEX|AMEX|PAGO_DESPUES|PASSCARD|SISTARBANC|REDPAGOS|EDENRED|CLUB_DEL_ESTE|ANDA|CABAL|MASTER|OCAVISA_NET|VISA|OCA|CREDITOS_DIRECTOS|TOKE/.test(
        line?.data?.toUpperCase()
      )
    ) {
      let brandImage = null;
      switch (line?.data?.toUpperCase()) {
        case 'VISA':
        case 'VISA_NET':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_visa.svg').default}
              className={classes.brandImage}
              alt="VISA"
            />
          );
          break;
        case 'OCA':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_oca.svg').default}
              className={classes.brandImage}
              alt="OCA"
            />
          );
          break;
        case 'MASTER':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_master.svg').default}
              className={classes.brandImage}
              alt="MASTER"
            />
          );
          break;
        case 'CABAL':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_cabal.svg').default}
              className={classes.brandImage}
              alt="CABAL"
            />
          );
          break;
        case 'ANDA':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_anda.svg').default}
              className={classes.brandImage}
              alt="ANDA"
            />
          );
          break;
        case 'CLUB_DEL_ESTE':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_clubdeleste.svg').default}
              className={classes.brandImage}
              alt="CLUB_DEL_ESTE"
            />
          );
          break;
        case 'EDENRED':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_edenred.svg').default}
              className={classes.brandImage}
              alt="EDENRED"
            />
          );
          break;
        case 'REDPAGOS':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_redpagos.svg').default}
              className={classes.brandImage}
              alt="REDPAGOS"
            />
          );
          break;
        case 'SISTARBANC':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_sistarbanc.svg').default}
              className={classes.brandImage}
              alt="SISTARBANC"
            />
          );
          break;
        case 'PASSCARD':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_passcard.svg').default}
              className={classes.brandImage}
              alt="PASSCARD"
            />
          );
          break;
        case 'PAGO_DESPUES':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_pago_despues.svg').default}
              className={classes.brandImage}
              alt="PAGO_DESPUES"
            />
          );
          break;
        case 'AMEX':
        case 'SCOTIA_AMEX':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_scotia_amex.svg').default}
              className={classes.brandImage}
              alt="SCOTIA_AMEX"
            />
          );
          break;
        case 'SCOTIABANK':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_scotiabank.svg').default}
              className={classes.brandImage}
              alt="SCOTIABANK"
            />
          );
          break;
        case 'BROU':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_brou.svg').default}
              className={classes.brandImage}
              alt="BROU"
            />
          );
          break;
        case 'ITAU':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_itau.svg').default}
              className={classes.brandImage}
              alt="ITAU"
            />
          );
          break;
        case 'BBVA':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_bbva.svg').default}
              className={classes.brandImage}
              alt="BBVA"
            />
          );
          break;
        case 'BANDES':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_bandes.svg').default}
              className={classes.brandImage}
              alt="BANDES"
            />
          );
          break;
        case 'CREDITOS_DIRECTOS':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_creditos_directos.png').default}
              className={classes.brandImage}
              alt="CREDITOS_DIRECTOS"
            />
          );
          break;
        case 'TOKE':
          brandImage = (
            <img
              src={require('../../static/images/brands/brand_toke.svg').default}
              className={classes.brandImage}
              alt="TOKE"
            />
          );
          break;
        default:
          brandImage = null;
          break;
      }
      return (
        <div className={classes.boxBrandImage} title={line?.data}>
          {brandImage}
        </div>
      );
    }

    return line?.text ? line?.text : '-'
  }

  const renderOperationTypeLines = (lines) => {
    return lines ? (
      <List className={classes.boxContent}>
        {lines.map((line, index) => {
          return <React.Fragment key={index}>
            {index !== 0 ? <Divider /> : null}
            <ListItem className={classes.boxContentItem}>
              {renderOperationTypesLabels(line.data)}
              <div className={classes.summaryAmount}>
                {renderCardAuthorizationLineText(
                  line.text,
                  [ 0, 6 ].includes(index),
                  index === 0, /* Transaction Date */
                )}
              </div>
            </ListItem>
          </React.Fragment>
        })}
      </List>
    ) : null;}

  const renderPaymentMethodData = (lines) => {
    return lines ? (
      <List className={classes.boxContent}>
        {lines.map((line, index) => {
          return <React.Fragment key={index}>
            {index !== 0 ? <Divider /> : null}
            <ListItem className={classes.boxContentItem}>
              {renderPaymentMethodDataLabels(line.data)}
              <div className={classes.summaryAmount}>
                {renderPaymentMethodLineText(
                  line
                )}
              </div>
            </ListItem>
          </React.Fragment>
        })}
      </List>
    ) : null;}

  const renderChannelData = (lines) => {
    const mediumKey = i18n.get('OperationDetails.MediumKey');
    const ecommerceText = i18n.get('OperationDetails.EcommerceText');
    const showEcommerceId = lines.some(line => line.data === mediumKey && (line.text === ecommerceText));
    return lines ? (
      <List className={classes.boxContent}>
        {lines.map((line, index) => {
          return !showEcommerceId && lines.length - 1 === index ? null : <React.Fragment key={index}>
            {index !== 0 ? <Divider /> : null}
            <ListItem className={classes.boxContentItem}>
              {renderCardAuthorizationLineLabel(line.data)}
              <div className={classes.summaryAmount}>
                {renderCardAuthorizationLineText(
                  line.text
                )}
              </div>
            </ListItem>
          </React.Fragment>
        })}
      </List>
    ) : null;
  }

  const renderInvoiceDetails = (details = []) => (
    <List className={classes.boxContent}>{details.map(renderInvoiceDetailLines)}</List>
  );

  const renderInvoiceDetailLines = (details, detailsIndex) => {
    const invoiceDetailsLines = isAccordion =>
      details.lines.map((line, index) => (
        <ListItem key={index} className={classes.summaryItem}>
          {isAccordion ? (
            <React.Fragment>
              <Hidden xsDown>
                <ListItemText primary={line.text} className={classes.summaryTitle} />
                <ListItemSecondaryAction className={classes.summaryAmount}>
                  {line.currency} {Utils.formatCurrency(line.total)}
                </ListItemSecondaryAction>
              </Hidden>
              <Hidden smUp>
                <div
                  className={clsx(
                    classes.summaryItemWrapper,
                    index === details.lines.length - 1 ? classes.summaryItemNoBorder : null
                  )}
                >
                  <div className={classes.summaryTitle}>{line.text}</div>
                  <div className={classes.summaryAmount}>
                    {line.currency} {Utils.formatCurrency(line.total)}
                  </div>
                </div>
              </Hidden>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <ListItemText primary={line.text} className={classes.summaryTitle} />
              <ListItemSecondaryAction className={classes.summaryAmount}>
                {line.currency} {Utils.formatCurrency(line.total)}
              </ListItemSecondaryAction>
            </React.Fragment>
          )}
        </ListItem>
      ));

    if (details.title) {
      return (
        <React.Fragment key={detailsIndex}>
          {detailsIndex !== 0 ? <Divider /> : null}
          <Accordion className={classes.boxAccordion}>
            <AccordionSummary className={classes.boxAccordionSummary} expandIcon={<ExpandMoreIcon />}>
              <div>{details.title}</div>
              <div className={classes.summaryAmount}>
                {details.lines[0].currency} {Utils.formatCurrency(details.total)}
              </div>
            </AccordionSummary>
            <AccordionDetails className={classes.boxAccordionLines}>
              <Divider />
              <div className={classes.boxAccordionLinesWrapper}>{invoiceDetailsLines(true)}</div>
            </AccordionDetails>
          </Accordion>
          <Divider />
        </React.Fragment>
      );
    }

    return invoiceDetailsLines();
  };

  if (forbiddenSection) {
    return (
      <Page withHeader withSidebar withHeaderTitle={i18n.get('OperationDetails.Title')}>
        <ForbiddenSection />
      </Page>
    );
  }

  return (
    <Page withHeader withSidebar withHeaderTitle={i18n.get('OperationDetails.Title')}>
      <TitleBox
        title={`${i18n.get('OperationDetails.BoxTitle')} ${getOperationTypeTitle()}`}
        back
        backTitle={i18n.get('OperationDetails.BoxBackTitle')}
        onBackClick={_goBack}
        backButtonVariant="outlined"
      />
      <BoxSeparator size='small' />
      {hasOperationDetails ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}  order={{ xs: 2, md: 1 }} >
            <Accordion defaultExpanded  className={classes.accordion}>
              <AccordionSummary expandIcon={<ExpandMoreIcon/>} classes={{
                  root: classes.accordionSummary,
                  expanded: classes.accordionSummaryExpanded,
                }}>
                <div>
                  {`${i18n.get('OperationDetails.OperationsTypeText')} ${getOperationTypeTitle()}`}
                </div>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>         
                <div className={classes.boxContentWrapper}>
                  {renderOperationTypeLines(groupedOperationDetails.operationType)}
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded  className={classes.accordion}>
              <AccordionSummary expandIcon={<ExpandMoreIcon/>}  classes={{
                  root: classes.accordionSummary,
                  expanded: classes.accordionSummaryExpanded,
                }}>
                <div>
                  {i18n.get('OperationDetails.PaymentMethodTitle')}
                </div>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>         
                <div className={classes.boxContentWrapper}>
                  {renderPaymentMethodData(groupedOperationDetails.paymentMethod)}
                </div>
              </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded  className={classes.accordion}>
              <AccordionSummary expandIcon={<ExpandMoreIcon/>} classes={{
                  root: classes.accordionSummary,
                  expanded: classes.accordionSummaryExpanded,
                }}>
                <div>
                 {i18n.get('OperationDetails.ChannelDataTitle')}
                </div>
              </AccordionSummary>
              <AccordionDetails className={classes.accordionDetails}>         
                <div className={classes.boxContentWrapper}>
                  {renderChannelData(groupedOperationDetails.channel)}
                </div>
              </AccordionDetails>
            </Accordion>
          </Grid>
          <Grid item xs={12} sm={12} md={6} className={classes.firstOnMobile}>
            <Box>
              <div className={classes.summaryWrapper}>
               <div>
                  {`${i18n.get('OperationDetails.OperationSummaryTitle')} ${getOperationTypeTitle()}`}
                </div>
                <div className={classes.boxContentWrapper}>{renderInvoiceDetails(operationDetails.detail)}</div>
              </div>
            </Box>
          </Grid>
        </Grid>
      ) : null}
    </Page>
  );
};

OperationDetailsScreen.id = 'com.Handy.OperationDetails';

export default OperationDetailsScreen;
